import React from "react";

export default function ChipStaffName(props) {
  return (
    <div className="chip-staff-name-container">
      <div className="top-title-chip">Assigned Therapist</div>
      <div className="name-chip">{props.assignedTherapist} </div>
    </div>
  );
}
